"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IoSulphurResearch = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var IoSulphurResearch = (function (_super) {
    __extends(IoSulphurResearch, _super);
    function IoSulphurResearch() {
        return _super.call(this, {
            name: CardName_1.CardName.IO_SULPHUR_RESEARCH,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.JOVIAN],
            cost: 17,
            metadata: {
                cardNumber: '232',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.cards(1).br;
                    b.or().br;
                    b.venus(3).played.digit.colon().cards(3);
                }),
                description: 'Draw 1 card, or draw 3 if you have at least 3 Venus tags.',
                victoryPoints: 2,
            },
        }) || this;
    }
    ;
    IoSulphurResearch.prototype.play = function (player) {
        player.drawCard(player.getTagCount(Tags_1.Tags.VENUS) >= 3 ? 3 : 1);
        return undefined;
    };
    IoSulphurResearch.prototype.getVictoryPoints = function () {
        return 2;
    };
    return IoSulphurResearch;
}(Card_1.Card));
exports.IoSulphurResearch = IoSulphurResearch;
//# sourceMappingURL=IoSulphurResearch.js.map